import {Directive, HostBinding} from '@angular/core';

@Directive({
    selector: '[appHideScrollBar]',
    standalone: false
})
export class HideScrollBarDirective {
  @HostBinding('class.hide-scroll-bar') private always = true;
}
